import * as CryptoJS from 'crypto-js';

const secretKey = '12345..'; // Use a strong, unique key and keep it secure

export function encrypt(text: string): string {
  const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString();
  return encodeURIComponent(ciphertext); // URL-encode the encrypted string
}

export function decrypt(ciphertext: string): string {
  const decodedCiphertext = decodeURIComponent(ciphertext); // URL-decode the encrypted string
  const bytes = CryptoJS.AES.decrypt(decodedCiphertext, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
}
